// src/pages/ServicesPage.js dosyasının ilgili kısmı
import { Link } from 'react-router-dom'; // Link'i import et
import { servicesData } from '../data/servicesData'; // Datayı import et (aynı veriyi kullanalım)
import styles from '../css/ServicesPage.module.css';

const ServicePage = () => {

  return (
    <div className={styles.servicesContainer} id="services">
       {/* ... Header kısımları aynı ... */}
       
       <div className={styles.grid}>
        {servicesData.map((service, index) => (
          <div key={index} className={styles.card}>
            <div className={styles.iconWrapper}>{service.icon}</div>
            <h3>{service.title}</h3>
            <p>{service.shortDesc}</p> {/* shortDesc kullanıyoruz */}
            
            {/* TIKLANABİLİR LİNK YAPTIK */}
            <Link to={`/hizmet/${service.slug}`} className={styles.detailLink}>
               İncele &rarr;
            </Link>
            
            <div className={styles.cardHoverEffect}></div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServicePage;